"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _UIIconButton = _interopRequireDefault(require("UIComponents/button/UIIconButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  vertical-align: middle !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUIIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "ToolbarButton__StyledUIIcon",
  componentId: "sc-53v92k-0"
})(_templateObject());

var ToolbarButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ToolbarButton, _Component);

  function ToolbarButton() {
    (0, _classCallCheck2.default)(this, ToolbarButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToolbarButton).apply(this, arguments));
  }

  (0, _createClass2.default)(ToolbarButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconName = _this$props.iconName,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["iconName"]);
      return _react.default.createElement(_UIIconButton.default, (0, _extends2.default)({
        className: "mce-hubspot-button p-all-1",
        use: "unstyled"
      }, rest), _react.default.createElement(StyledUIIcon, {
        name: iconName,
        size: 14
      }));
    }
  }]);
  return ToolbarButton;
}(_react.Component);

exports.default = ToolbarButton;
ToolbarButton.propTypes = {
  iconName: _UIIcon.default.propTypes.name
};
module.exports = exports.default;